"use client";
import { Carousel, Card } from "@/components/ui/apple-cards-carousel";

const steps = [
  {
    src: "/images/landing/HowShoppingWorks/1.png",
    title: "Link Your Instacart Account",
    belowImageDescription: "Link your Instacart account to Batchfinder",
  },
  {
    src: "/images/landing/HowShoppingWorks/2.png",
    title: "Set Your Location",
    belowImageDescription: "Set your location to store with high deamnd",
  },
  {
    src: "/images/landing/HowShoppingWorks/3.png",
    title: "Update Your Filters",
    belowImageDescription: "Set your preferences: pay, distance, and more",
  },
  {
    src: "/images/landing/HowShoppingWorks/4.png",
    title: "Start the Bot",
    belowImageDescription: "Start the bot and let it auto-grab for you",
  },
  {
    src: "/images/landing/HowShoppingWorks/5.png",
    title: "Time to Go",
    belowImageDescription: "A batch gets grabbed — time to head out",
  },
  {
    src: "/images/landing/HowShoppingWorks/6.png",
    title: "Start Shopping",
    belowImageDescription: "Press \"Start Shopping\" and go",
  },
];

export function HowShoppingWorksAppleCarousel() {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-primary">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl sm:text-3xl md:text-4xl font-bold text-left mb-2 text-white">
          How shopping <br /> with Batchfinder <br /> works
        </h2>
        <Carousel
          items={steps.map((card, i) => (
            <Card key={i} card={card} index={i} layout={false} belowImageDescription={card.belowImageDescription} />
          ))}
        />
      </div>
    </section>
  );
} 